"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const next_components_price_1 = __importStar(require("@gerenciatd/next.components.price"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const SearchInput_1 = __importStar(require("../../SearchInput"));
const next_components_text_info_n_1 = __importStar(require("@gerenciatd/next.components.text-info-n"));
const next_app_controller_reducers_sagas_main_reducer_n_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n");
const next_app_controller_reducers_sagas_modals_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.modals-reducer");
const next_app_controller_reducers_sagas_header_reducer_1 = require("@gerenciatd/next.app-controller.reducers-sagas.header-reducer");
const INPUT_ID = 'inputsupportadnsearch';
const PAGE = 'page';
const PAGE_TITLE = 'Contenidos relacionados';
const DEVICE = 'device';
const DEVICE_TITLE = 'Dispositivos relacionados';
const SERVICE = 'service';
const SERVICE_TITLE = 'Servicios relacionados';
const DEVICE_PRICE = {
    color: next_components_price_1.PRICE_COLORS.BLUE_DARK,
    size: next_components_price_1.PRICE_SIZE.CAPTION1,
    fontType: next_components_price_1.PRICE_FONT_TYPE.BOLD
};
const TITLE_RESULT_SECTION_PROPS = {
    level: next_components_text_info_n_1.TEXT_INFO_HEADING_LEVEL.H3,
    kind: next_components_text_info_n_1.TEXT_INFO_KIND.HEADING,
    fontType: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.REGULAR,
    size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1,
    display: next_components_text_info_n_1.TEXT_INFO_DISPLAY.BLOCK,
};
const RESULT_TEXT_INFO_PROPS = {
    color: next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_4A,
    size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1,
    fontType: next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.LIGHT,
    kind: next_components_text_info_n_1.TEXT_INFO_KIND.SPAN
};
const taggingInfo2AT = {
    componentName: 'searcher',
    componentProduct: '',
    componentVariation: 'asistente-virtual',
    componentPerso: '',
};
class SupportAndSearch extends react_1.Component {
    constructor(props) {
        super(props);
        this.drawModal = () => {
            try {
                let positiontop = (document.querySelector('.HeaderM .MovistarMenu').clientHeight +
                    document.querySelector('.HeaderM .TopBar').clientHeight);
                const modalParent = document.querySelector('.modal-root');
                modalParent.style.zIndex = "11";
                modalParent.style.height = `calc(100vh - ${parseInt(positiontop, 10)}px)`;
                modalParent.style.top = `${parseInt(positiontop, 10) - 2}px`;
                document.querySelector('.SectionMenu').style.boxShadow = "none";
            }
            catch (err) {
                console.error(err);
            }
        };
        this.go2AT = ({ label, }) => {
            document.getElementById('hidden-query').value = "1";
            (0, SearchInput_1.handleAtRequest)({
                label,
                checkAt: false,
                checkPages: false,
                event: null
            });
        };
        this.resultOnClick = ({ pathName, taggingInfo }) => {
            const { inputQuery } = this.props;
            const name = taggingInfo.componentName;
            const content = encodeURIComponent(inputQuery);
            const variation = taggingInfo.componentVariation;
            const getTokken = pathName.indexOf('?') === -1 ? '?' : '&';
            window.location.href = `${pathName}${getTokken}name=${name}&content=${content}&variation=${variation}`;
        };
        /*
          kind: 'servicios' or 'devicepage', 'default
        */
        this.renderResultsLinks = (kind, results) => {
            const { inputQuery } = this.props;
            if (!results || results.length === 0) {
                return null;
            }
            let titleLabel = '';
            switch (kind) {
                case DEVICE:
                    titleLabel = DEVICE_TITLE;
                    break;
                case SERVICE:
                    titleLabel = SERVICE_TITLE;
                    break;
                default:
                    titleLabel = PAGE_TITLE;
                    break;
            }
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ className: kind === SERVICE ? 'results-t results-service' : 'results-t results-device', text: titleLabel }, TITLE_RESULT_SECTION_PROPS)),
                results && Array.isArray(results) && (react_1.default.createElement("div", { className: "SearcherResultsGaps" }, results.map(pageElement => {
                    let { pathName, key, label } = pageElement;
                    if (!key) {
                        key = label;
                    }
                    const ariaLabelTitle = `Visitar ${pathName}`;
                    const currentComponentContent = `https://www.movistar.es${pathName}|${inputQuery}`;
                    if (kind === SERVICE) {
                        const { name: productName, amount: priceProduct } = pageElement;
                        const currentTaggingInfo = {
                            componentProduct: '',
                            componentName: 'searcher',
                            componentContent: currentComponentContent,
                            componentVariation: SERVICE
                        };
                        return (react_1.default.createElement(next_components_custom_link_1.default, { key: productName, title: ariaLabelTitle, ariaLabel: ariaLabelTitle, className: "itemLink", onClick: () => this.resultOnClick({
                                pathName,
                                taggingInfo: currentTaggingInfo,
                            }), taggingInfo: currentTaggingInfo, forceExternal: true },
                            react_1.default.createElement("div", { className: "ServiceGap" },
                                react_1.default.createElement("div", { className: "ServiceDetails" },
                                    react_1.default.createElement("div", { className: "DeviceName" },
                                        react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, RESULT_TEXT_INFO_PROPS, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1, align: "left", display: "block", text: productName }))),
                                    react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, RESULT_TEXT_INFO_PROPS, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION3, color: next_components_text_info_n_1.TEXT_INFO_COLOR.GREY4, align: "left", className: "prePriceText", display: next_components_text_info_n_1.TEXT_INFO_DISPLAY.BLOCK, text: "Desde " })),
                                    react_1.default.createElement(next_components_price_1.default, Object.assign({}, DEVICE_PRICE, { unity: pageElement.unity, amount: priceProduct }))))));
                    }
                    else {
                        // significa que es un dispositivo
                        const picture2Show = pageElement.img;
                        const currentTaggingInfo = {
                            componentProduct: '',
                            componentName: 'searcher',
                            componentContent: currentComponentContent,
                            componentVariation: DEVICE
                        };
                        return (react_1.default.createElement(next_components_custom_link_1.default, { key: key, title: ariaLabelTitle, ariaLabel: ariaLabelTitle, className: "itemLink", onClick: () => this.resultOnClick({
                                pathName,
                                taggingInfo: currentTaggingInfo,
                            }), taggingInfo: {
                                componentProduct: '',
                                componentName: 'searcher',
                                componentContent: currentComponentContent,
                                componentVariation: DEVICE
                            }, forceExternal: true },
                            react_1.default.createElement("div", { className: "DeviceGap" },
                                react_1.default.createElement("div", { className: "DevicePicture" },
                                    react_1.default.createElement("img", { className: 'absolute2show', loading: "lazy", src: `https://prod.cms.col.movistar.es${picture2Show}` }),
                                    react_1.default.createElement("img", { className: "relative2fill", loading: "lazy", src: `https://prod.cms.col.movistar.es${picture2Show}` })),
                                react_1.default.createElement("div", { className: "DeviceDetails" },
                                    react_1.default.createElement("div", { className: "DeviceName" },
                                        react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, RESULT_TEXT_INFO_PROPS, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1, align: "left", display: "block", text: pageElement.name }))),
                                    react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, RESULT_TEXT_INFO_PROPS, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION3, align: "left", className: "prePriceText", text: pageElement.prePrice, color: next_components_text_info_n_1.TEXT_INFO_COLOR.GREY4, display: next_components_text_info_n_1.TEXT_INFO_DISPLAY.BLOCK })),
                                    react_1.default.createElement(next_components_price_1.default, Object.assign({}, DEVICE_PRICE, { unity: pageElement.unity, amount: pageElement.amount }))))));
                    }
                })))));
        };
        this.renderAutogeneratedPagesAndAv = () => {
            const { querySuggestedInputs, categoriesMatched, inputQuery } = this.props;
            let finalData2Render = [];
            if (querySuggestedInputs && querySuggestedInputs.length > 0) {
                finalData2Render = [
                    ...querySuggestedInputs,
                ];
            }
            if (categoriesMatched && categoriesMatched.length > 0) {
                finalData2Render = [
                    ...categoriesMatched.slice(0, 3),
                    ...finalData2Render,
                ];
            }
            finalData2Render = finalData2Render.slice(0, 3);
            if (finalData2Render && finalData2Render.length > 0) {
                return (react_1.default.createElement("div", { className: `ResultsSection ${PAGE}` },
                    react_1.default.createElement("div", { className: "PageResultsContainer" },
                        react_1.default.createElement("div", { className: "SupportAndSearchContainer container " }, finalData2Render.map((pageElement) => {
                            let { key, label } = pageElement;
                            let ariaLabelTitle = `Buscar ${label}`;
                            let currentTaggingInfo = {
                                componentProduct: '',
                                componentName: 'searcher',
                                componentContent: `${label}|${inputQuery}`,
                                componentVariation: 'asistente-virtual'
                            };
                            let onClick = () => this.go2AT({
                                label,
                                taggingInfo: currentTaggingInfo,
                            });
                            if (pageElement.kind === 'page') {
                                const { pathName } = pageElement;
                                ariaLabelTitle = `Visitar ${pathName}`;
                                currentTaggingInfo = Object.assign(Object.assign({}, currentTaggingInfo), { componentContent: `https://www.movistar.es${pathName}|${inputQuery}`, componentVariation: PAGE });
                                onClick = () => this.resultOnClick({
                                    pathName,
                                    taggingInfo: currentTaggingInfo,
                                });
                            }
                            let title = ariaLabelTitle;
                            let ariaLabel = ariaLabelTitle;
                            return (react_1.default.createElement(next_components_custom_link_1.default, { key: key, className: "itemLink", onClick: onClick, title: title, ariaLabel: ariaLabel, taggingInfo: currentTaggingInfo, forceExternal: true },
                                react_1.default.createElement("div", { className: "itemLink-element" },
                                    react_1.default.createElement(next_components_icon_n_1.default, { id: "CheuronRight", size: 14 }),
                                    react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({}, RESULT_TEXT_INFO_PROPS, { text: label })))));
                        })))));
            }
            return null;
        };
        this.state = {};
    }
    componentDidMount() {
        this.drawModal();
        window.addEventListener('resize', this.drawModal);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.drawModal);
        // deshago el desastre del css
        const modalParent = document.querySelector('.modal-root');
        modalParent.style.removeProperty('z-index');
        modalParent.style.removeProperty('top');
        modalParent.style.removeProperty('height');
        // restablezco valores iniciales
        const { resetSearcher } = this.props;
        resetSearcher();
    }
    render() {
        const { props, state, } = this;
        const { kind, querySuggestedInputs, pagesSuggestedList, resetSearcher, visibleInput, inputQuery, categoriesMatched } = props;
        const { shouldSendAT } = state;
        const myProps = {};
        myProps.handleSearch = null;
        if (props.urlSupport) {
            myProps.handleSearch = (evt) => {
                this.handleAtRequest({
                    evt,
                    shouldSendAT: true,
                    taggingInfo: taggingInfo2AT
                });
            };
        }
        const checkIfThereAreNoResults = !pagesSuggestedList || (pagesSuggestedList.regular && pagesSuggestedList.regular.length === 0 &&
            pagesSuggestedList.services && pagesSuggestedList.services.length === 0 &&
            pagesSuggestedList.devices && pagesSuggestedList.devices.length === 0);
        const checkNoATLinks = !querySuggestedInputs || querySuggestedInputs.length === 0;
        if (!visibleInput && checkIfThereAreNoResults && checkNoATLinks) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "SupportAndSearch" },
            react_1.default.createElement("div", { className: `SupportAndSearchContainer container ${kind}` },
                visibleInput && (react_1.default.createElement("div", { className: "SearcherGap" },
                    react_1.default.createElement(SearchInput_1.default, { id: INPUT_ID, autoComplete: "off", handleSearch: myProps.handleSearch, placeHolder: "Buscar en Movistar", shouldSendAT: shouldSendAT, backButton: true, autoFocus: true, taggingInfo: taggingInfo2AT, onClear: resetSearcher }))),
                pagesSuggestedList && pagesSuggestedList.regular && pagesSuggestedList.regular.length > 0 && (react_1.default.createElement("div", { className: "SuggestedInput" }, pagesSuggestedList.regular.map(item => {
                    const { pathName, key, name } = item;
                    const ariaLabel = `Visitar ${pathName}`;
                    const currentTagginInfo = Object.assign(Object.assign({}, taggingInfo2AT), { componentContent: `${name}|${inputQuery}`, componentVariation: PAGE });
                    return (react_1.default.createElement(next_components_custom_link_1.default, { onClick: () => {
                            this.resultOnClick({
                                pathName,
                                taggingInfo: currentTagginInfo
                            });
                        }, title: ariaLabel, ariaLabel: ariaLabel, taggingInfo: currentTagginInfo },
                        react_1.default.createElement("div", { className: 'SuggestedItem' },
                            react_1.default.createElement(next_components_icon_n_1.default, { id: "Buscar", size: 16, color: next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE }),
                            react_1.default.createElement(next_components_text_info_n_1.default, Object.assign({ className: "suggested-label" }, RESULT_TEXT_INFO_PROPS, { key: key, text: name, color: next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE })))));
                }))),
                pagesSuggestedList && (pagesSuggestedList.devices.length > 0 || pagesSuggestedList.services.length > 0) && (react_1.default.createElement("div", { className: "linksListContainer" },
                    pagesSuggestedList && pagesSuggestedList.devices && pagesSuggestedList.devices.length > 0 && (react_1.default.createElement("div", { className: `ResultsSection ${DEVICE}` }, this.renderResultsLinks(DEVICE, pagesSuggestedList.devices))),
                    pagesSuggestedList && pagesSuggestedList.services && pagesSuggestedList.services.length > 0 && (react_1.default.createElement("div", { className: `ResultsSection ${SERVICE}` }, this.renderResultsLinks(SERVICE, pagesSuggestedList.services)))))),
            this.renderAutogeneratedPagesAndAv()));
    }
}
SupportAndSearch.propTypes = {
    visibleInput: prop_types_1.default.bool
};
SupportAndSearch.defaultProps = {
    visibleInput: true,
};
const mapStateToProps = (state) => ({
    categoriesMatched: state.header.categoriesMatched,
    querySuggestedInputs: state.header.querySuggestedInputs,
    pagesSuggestedList: state.header.pagesSuggestedList,
    inputQuery: state.header.inputQuery,
});
const mapDispatchToProps = (dispatch) => ({
    sendCmsEvent: data => dispatch(next_app_controller_reducers_sagas_main_reducer_n_1.actions.sendCmsEvent(data)),
    addModal: (data) => dispatch(next_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
    getSearcherInfo: () => dispatch(next_app_controller_reducers_sagas_header_reducer_1.actions.getSearcherInfo()),
    getSuggestedInputs: (query) => dispatch(next_app_controller_reducers_sagas_header_reducer_1.actions.getSuggestedInputs(query)),
    getRelatedPages: (query) => dispatch(next_app_controller_reducers_sagas_header_reducer_1.actions.getRelatedPages(query)),
    resetSearcher: () => dispatch(next_app_controller_reducers_sagas_header_reducer_1.actions.resetSearcher()),
    throwSonda: data => dispatch(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(SupportAndSearch);
//# sourceMappingURL=index.js.map